module.exports = "/_next/static/images/cf2eec7d006d3848eada4bb3c2087787-slide1desktop.jpg";